import * as React from "react";
import { forwardRef } from "react";
const SvgUnderline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 18, viewBox: "0 0 12 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1V8C1 9.32608 1.52678 10.5979 2.46447 11.5355C3.40215 12.4732 4.67392 13 6 13C7.32608 13 8.59785 12.4732 9.53553 11.5355C10.4732 10.5979 11 9.32608 11 8V1M1 17H11", stroke: "#5A6367", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgUnderline);
export { ForwardRef as ReactComponent };
